import { FCX, Tooltip, useUuid } from '@datassential/platform-ui-lib';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import StrengthsWeaknesses from '@components/StrengthsWeaknesses/StrengthsWeaknesses';
import './ConsumerRatingsStrengthsWeaknesses.scss';

interface ConsumerRatingsStrengthsWeaknessesProps {
    strengths: string[];
    weaknesses: string[];
    presetName?: string;
    chainName: string;
}

const ConsumerRatingsStrengthsWeaknesses: FCX<ConsumerRatingsStrengthsWeaknessesProps> = ({
    strengths,
    weaknesses,
    presetName,
    chainName,
}) => {
    const tooltipId = useUuid();

    if (!strengths.length && !weaknesses.length) return null;

    return (
    <div className="ConsumerRatingsStrengthsWeaknesses">
        <div className="ConsumerRatingsStrengthsWeaknesses__header">
            <span className="ConsumerRatingsStrengthsWeaknesses__title">Strengths & Weaknesses</span>
            <AiOutlineInfoCircle
                className="ConsumerRatingsStrengthsWeaknesses__info-icon"
                data-tooltip-id={tooltipId}
            />
            <Tooltip id={tooltipId} place="top" style={{ zIndex: 1, maxWidth: 270 }}>
                Compared to <b>{presetName}</b>, these are top strengths and areas of opportunity
                for <b>{chainName}</b> based on % of consumers rating the chain "best in class" or
                "above average" on these attributes.
            </Tooltip>
        </div>
        <StrengthsWeaknesses
            strengths={strengths}
            weaknesses={weaknesses}
        />
    </div>
    );
};

export default ConsumerRatingsStrengthsWeaknesses;
